'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var EFFECTIVE_IMMEDIATELY = exports.EFFECTIVE_IMMEDIATELY = 'immediately';
var EFFECTIVE_NEXT_CYCLE = exports.EFFECTIVE_NEXT_CYCLE = 'next-cycle';